// extracted by mini-css-extract-plugin
module.exports = {"parity":"Parity_parity__jRuyD","parity__wrapper":"Parity_parity__wrapper__Vzomo","parity__text":"Parity_parity__text__0N8xk"};